import type { RootState } from '~/src/redux/store';
import type {
    SuggestedOrganizationType,
} from '~/src/components/blocks/clients-request/organization-info/organization-info.types';

export const selectReferralCode = (state: RootState): string =>
    state.referralLead.referralCode;

export const selectReferralProductsUrl = (state: RootState): string =>
    state.referralLead.referralProductsUrl;

export const selectSuggestedOrganization = (state: RootState): SuggestedOrganizationType =>
    state.referralLead.suggestedOrganization;

export const selectDomainUrl = (state: RootState) =>
    state.referralLead.domainUrl;

export const selectCurrentNameTariff = (state: RootState) =>
    state.referralLead.currentNameTariff;